if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        
        // --- CHANGEMENT 1 : On définit le type en JSON ---
        config.headers["Content-Type"] = "application/json";
        // On supprime la ligne "delete config.headers..." qui était là avant
        // --- CHANGEMENT 2 : On construit un objet JSON ---
        let formData = new FormData(this.form);
        let jsonData = {};
        // On convertit le FormData en objet simple
        for (const [key, value] of formData.entries()) {
          jsonData[key] = value;
        }
        // --- GESTION DES SECTIONS (Format JSON) ---
        let sections = [];
        if (this.cartNotification) {
          const notifSections = this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id);
          sections.push(...notifSections);
        }
        if (this.cartItems) {
          const itemSections = this.cartItems
            .getSectionsToRender()
            .map((section) => section.section);
          sections.push(...itemSections);
        }
        if (sections.length > 0) {
          jsonData.sections = sections; // Envoi propre en tableau ou liste
        }
        
        jsonData.sections_url = window.location.pathname;
        config.body = JSON.stringify(jsonData);
        // --- FETCH (On vise cart/add.js pour être sûr du retour JSON) ---
        // On s'assure que l'URL finit par .js
        const url = routes.cart_add_url.endsWith('.js') 
                    ? routes.cart_add_url 
                    : `${routes.cart_add_url}.js`;
        fetch(url, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }
            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }
            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            if (this.quickViewWarpper) {
                 this.quickViewWarpper.classList.remove("show__modal");
            }
            document.body.classList.remove("overflow-hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
